import { cn } from "@/lib/utils";

const gradeColors = {
  A: { color: "#10B981", bg: "#D1FAE5", glow: "rgba(16, 185, 129, 0.3)" },
  B: { color: "#84CC16", bg: "#ECFCCB", glow: "rgba(132, 204, 22, 0.3)" },
  C: { color: "#EAB308", bg: "#FEF9C3", glow: "rgba(234, 179, 8, 0.3)" },
  D: { color: "#F97316", bg: "#FFEDD5", glow: "rgba(249, 115, 22, 0.3)" },
  F: { color: "#EF4444", bg: "#FEE2E2", glow: "rgba(239, 68, 68, 0.3)" }
};

export const ScoreCircle = ({ score, grade, size = "md" }) => {
  const colors = gradeColors[grade] || gradeColors.F;
  const radius = size === "lg" ? 50 : size === "md" ? 38 : 28;
  const strokeWidth = size === "lg" ? 10 : size === "md" ? 7 : 5;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (score / 100) * circumference;
  
  const sizeClasses = {
    sm: "w-20 h-20",
    md: "w-28 h-28",
    lg: "w-36 h-36"
  };
  
  const textSizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-4xl"
  };
  
  const gradeSizes = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base"
  };

  return (
    <div 
      className={cn("relative", sizeClasses[size])} 
      data-testid="score-circle"
      style={{
        filter: `drop-shadow(0 0 20px ${colors.glow})`
      }}
    >
      <svg className="w-full h-full transform -rotate-90">
        {/* Glow effect */}
        <defs>
          <linearGradient id={`scoreGradient-${grade}`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={colors.color} stopOpacity="1" />
            <stop offset="100%" stopColor={colors.color} stopOpacity="0.7" />
          </linearGradient>
        </defs>
        
        {/* Background circle */}
        <circle
          cx="50%"
          cy="50%"
          r={radius}
          fill="none"
          stroke={colors.bg}
          strokeWidth={strokeWidth + 2}
        />
        
        {/* Progress circle */}
        <circle
          cx="50%"
          cy="50%"
          r={radius}
          fill="none"
          stroke={`url(#scoreGradient-${grade})`}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className="score-circle"
          style={{
            transition: "stroke-dashoffset 1.5s ease-out"
          }}
        />
      </svg>
      
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className={cn("font-bold text-white font-['Outfit']", textSizes[size])}>
          {score}%
        </span>
        <span 
          className={cn("font-semibold font-['Outfit']", gradeSizes[size])}
          style={{ color: colors.bg }}
        >
          Grade {grade}
        </span>
      </div>
    </div>
  );
};

export default ScoreCircle;
